import React from "react";

import Modal, { IModal } from "../../../../../Components/Helpers/Modal";
import { CustomDimension } from "../../../../../Models/CustomDimension";
import LeadResultTypeLabelMask from "../../../../Constants/LeadResultTypeLabelMask";
import DispositionConfirmationForm, { IDispositionConfirmationFormProps } from "./ConfirmationForm";

export interface IDispositionModalProps
  extends Required<Pick<IModal, "confirmDisabled" | "confirmSpinner" | "handleClose" | "handleConfirm" | "open">>,
    Omit<IModal, "title" | "confirmDisabled" | "confirmSpinner" | "handleClose" | "handleConfirm" | "open"> {
  /** The currently selected lead result type. */
  leadResultType: CustomDimension<number>;
  /** The form that should be rendered within the modal content area. */
  formProps: IDispositionConfirmationFormProps;
}

/** The modal which contains the form with which the user confirms the disposition for the session. */
const DispositionModal: React.FC<IDispositionModalProps> = ({ leadResultType, formProps, ...rest }) => (
  <Modal
    confirmDisabledTooltip="An appointment must be selected."
    title={LeadResultTypeLabelMask[leadResultType.id] || leadResultType.name}
    {...rest}
  >
    <DispositionConfirmationForm {...formProps} />
  </Modal>
);

export default DispositionModal;
